var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row align-items-center"},[_c('div',{staticClass:"status-icon mr-3",class:`bg-${_vm.color}`}),_c('span',{staticClass:"crop-text"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }